import { Box } from "@mui/material";
import React from "react";

type Props = {
  children: React.ReactNode;
  width?: number;
  height?: number;
};

const MobileMockup = ({ children, width = 320, height = 648 }: Props) => {
  return (
    <Box
      sx={{
        position: "relative",
        width: width,
        height: height,
        borderRadius: "50px",
        overflow: "hidden",
        p: 1,
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: 999,
          pointerEvents: "none",
          width: "100%",
          height: "100%",
        }}
      >
        <img
          src="/mobile_mockup.png"
          alt="mobile"
          width={"100%"}
          height={"100%"}
        />
      </Box>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: "100%",
          minHeight: 0,
          zIndex: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default MobileMockup;
